import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgPersonalSafety = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12.5 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Zm0 2a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM11.5 12a1 1 0 0 1 0 2c-4.443 0-8 3.162-8 7a1 1 0 0 1-2 0c0-4.999 4.502-9 10-9ZM17.708 12.543l-.568.182c-.424.14-.848.289-1.246.44a15.28 15.28 0 0 0-.902.374l-.369.174c-.792.392-1.123.704-1.123 1.387 0 2.116.745 3.933 1.977 5.434.736.897 1.476 1.5 2.003 1.82a1 1 0 0 0 1.04 0c.527-.32 1.267-.923 2.003-1.82 1.232-1.501 1.977-3.318 1.977-5.434 0-.683-.331-.995-1.123-1.387l-.369-.174a15.28 15.28 0 0 0-.902-.373c-.266-.102-.543-.201-.823-.298l-.912-.3a14.32 14.32 0 0 0-.08-.025 1 1 0 0 0-.583 0Zm.195 2.037.097-.032.233.077c.397.13.794.27 1.161.41.297.113.562.221.783.323l.245.118.064.033-.012.187c-.122 1.364-.66 2.55-1.497 3.57l-.206.24a7.5 7.5 0 0 1-.639.635l-.132.111.084.072a7.483 7.483 0 0 1-1.06-1.058l-.175-.221c-.737-.97-1.21-2.083-1.323-3.35l-.013-.186.065-.033.245-.118c.221-.102.486-.21.783-.324.245-.093.503-.186.765-.276l.532-.178Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgPersonalSafety)
const Memo = memo(ForwardRef)
export default Memo
